const { makeStyles } = require('@mui/styles');

export const useStyles = makeStyles({
    modalTitle: {
        color: '##182D55',
        fontWeight: 'bold',
        fontSize: '18px',
        lineHeight: '22px'
    },
    textRowPrimary: {
        fontWeight: 600,
        fontSize: '13px',
        lineHeight: '20px',
        color: '#182D55'
    },
    textRowSecondary: {
        fontWeight: 500,
        fontSize: '13px',
        lineHeight: '20px',
        color: '#7D95A5'
    },
    textLabelForm: {
        fontWeight: '500',
        fontSize: '13px',
        lineHeight: '20px'
    },
    textRowDescription: {
        fontWeight: '400',
        fontSize: '12px',
        lineHeight: '18px',
        color: '#617380'
    },
    textRow: {
        fontWeight: 500,
        fontSize: '13px',
        lineHeight: '20px',
        color: '#182D55'
    },
    chipText: {
        fontWeight: 'bold',
        fontSize: '12px',
        lineHeight: '18px',
        borderRadius: '4px',
        padding: '4px'
    }
});
